import React, { useState } from "react"

import "~/components/Label/Label"
import "./Slider.scss"
import Label from "~/components/Label/Label"
import { playAlarm } from "~/utils/AlarmUtils"

export type SliderProps = {
  label: string
  value: number
  disabled?: boolean
  valueChanged?: (newValue: number) => void
}

function Slider(props: SliderProps) {
  const [value, setValue] = useState(props.value)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    playAlarm(parseFloat(event.target.value))
    setValue(parseFloat(event.target.value))
    if (props.valueChanged) {
      props.valueChanged(parseFloat(event.target.value))
    }
  }

  const { label, disabled } = props

  return (
    <div className="Slider">
      <Label text={label} />
      <input
        className="Slider__input"
        type="range"
        min="0.1"
        max="0.9"
        step="0.1"
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  )
}

export default Slider
